<template>
  <div class="page_serviceDoc">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
            <el-form-item label="名称:">
              <el-input v-model="listQuery.fileName" size="small" style="width: 180px;"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success" size="small" @click="getList()" style="margin-left:20px">搜索</el-button>
            </el-form-item>

          </el-form>
        </div>
      </div>
      <!-- <div class="top-right">
        <el-button type="success" size="small" @click="getList()" style="margin-right:24px">搜索</el-button>
      </div> -->
    </div>

    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>在线业务支持中心</el-breadcrumb-item>
          <el-breadcrumb-item>知识库</el-breadcrumb-item>
          <el-breadcrumb-item>客服常用文档</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div style="padding: 10px 20px;">
          <el-button size="small" type="primary" @click="uploadDoc">上传文档</el-button>
        </div>
        <el-table :data="tableData" ref="elTable" v-loading="loading" style="width: 100%" border class="doc_table">
          <el-table-column align="center" min-width="400" label="名称" prop="fileName" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <div class="fileName cp">{{ row.fileName }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="200" label="创建人" prop="creater" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" min-width="200" label="创建时间" prop="createTime" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">{{ row.createTime ? row.createTime.replace('T',' ') : '' }}</template>
          </el-table-column>
          <el-table-column align="center" width="200" label="操作">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="down(row.fileUrl,row.fileName)">下载</el-button>
                <el-popconfirm title="请确认是否删除" @confirm="del(row)" style="margin-left:10px;" v-if="row.creater == userName">
                  <el-button type="text" v-preventReClick slot="reference">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="listQuery.pageModel.page" :page-size="listQuery.pageModel.rows" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager,next,jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="上传文档" :visible.sync="showUpload" width="640px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="fileForm" :model="fileForm" class="re_down_form" label-width="100px">
        <el-form-item label="附件:" prop="fileUrl">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">上传附件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="名称:" prop="fileName">
          <el-input v-model="fileForm.fileName" size="small" clearable style="width:220px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showUpload = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmUpload" :loading="isBtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import xz from "./../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    components: {
      // ResourceComTabs
    },
    data() {
      return {
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [{
              property: 'createTime',
              order: 1
            }],
          },
          fileName: "",
          busiType: 2, //1社保政策  2客服文档
        },
        fileForm: {
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
          fileName: "",
          fileUrl: "",
          id: "",
          busiType: 2
        },
        rules: {
          fileUrl: {
            required: true,
            message: '请上传附件',
            trigger: 'change'
          },
          fileName: {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
        },
        userName: localStorage.userName,
        fileList: [],
        loading: false,
        tableData: [],
        showUpload: false,
        isBtnLoading: false,
        headPath: this.$store.state.EMP.docPath,
        totalCount: 0
      }
    },
    created() {
      this.getList()
    },
    mounted() {},
    methods: {
      getList() {
        this.loading = true;
        xz.ArdCurStat(this.listQuery, 'GetSocialSecurityFundPageList').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //分页
      handleCurrentChange(val) {
        this.listQuery.pageModel.page = Number(val)
        this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.pageModel.page = 1
        this.listQuery.pageModel.rows = Number(val)
        this.getList()
      },
      down(url, name) {
        let d = url.replace("\"", "").replace("\"", "");
        var path = this.headPath + d;
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.setAttribute('download', name);
        aTag.click();
      },
      uploadDoc() {
        this.fileList = [];
        this.fileForm = {
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
          fileName: "",
          fileUrl: "",
          id: "",
          busiType: 2
        }
        this.showUpload = true;
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      // 删除结算单附件
      handleFileRemove() {
        this.fileForm.fileUrl = '';
      },
      // 上传结算单附件
      success_handle(file) {
        this.fileForm.fileName = file.name;
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.fileForm.fileUrl = res;
          } else {
            this.fileForm.fileUrl = '';
            this.fileForm.fileName = '';
          }
        });
      },
      confirmUpload() {
        this.$refs["fileForm"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.ArdCurStat(this.fileForm, 'AddDelSocialSecurityFundFile').then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功')
                this.getList();
                this.isBtnLoading = false;
                this.showUpload = false;
              } else {
                this.$message.error(res.msg)
                this.getList();
                this.isBtnLoading = false;
              }
            })
          }
        })
      },
      del(row) {
        let d = {
          id: row.id,
          busiType: 2
        }
        this.loading = false;
        xz.ArdCurStat(d, 'AddDelSocialSecurityFundFile').then(res => {
          if (res.status == 'ok') {
            this.$message.success('删除成功')
            this.getList();
            this.loading = false;
          } else {
            this.$message.error(res.msg)
            this.getList();
            this.loading = false;
          }
        })
      }
    }
  }
</script>

<style scoped>
  .ftabs {
    background: #fff;
    width: 99%;
  }

  .fileName {
    color: #19bd92;
    text-decoration: underline;
  }
</style>

<style>
  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .page_serviceDoc .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_serviceDoc .doc_table .el-table__body td.el-table__cell {
    padding: 8px 0;
  }

  .page_serviceDoc .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_serviceDoc .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>